import * as Store from '../../store'
import LoginActionTypes from '../Utility/LoginActionTypes';
import AllActionTypes from './AllActionTypes'
import { CLEAR_STORES } from '../../Actions/StoreActions'
import axios from 'axios';
import LoginUtility from '../Utility/Utility'
import { createHashHistory } from 'history';

// get api api configure fn
export const get = (url, data, header = "global", customHeaders = null) => {
	return new Promise((resolve, reject) => {
		// Check if URL is external (starts with http:// or https://)
		let apiBaseUrl;
		if (url.startsWith('http://') || url.startsWith('https://')) {
			apiBaseUrl = url; // Use external URL as-is
		} else {
			apiBaseUrl = normalizeUrl(`${process.env.BASE_URL}${url}`); // Use internal URL with base
		}

		var params = data ? data.filters : {};
		let invokeError = true;
		if (typeof params == "string") {
			params = JSON.parse(params)
			if (params.size_width && params.size_height) invokeError = false;
		}

		let requestHeaders = getHeaders(header, url);

		// Merge custom headers if provided
		if (customHeaders && typeof customHeaders === 'object') {
			requestHeaders = { ...requestHeaders, ...customHeaders };
		}

		// console.log(`🌐 GET Request: ${url}`, {
		// 	authType: header,
		// 	hasWebhookKey: !!requestHeaders['x-wh-api-key'],
		// 	hasAuthToken: !!requestHeaders['Authorization'],
		// 	hasCustomApiKey: !!requestHeaders['x_ms_api_key'],
		// 	finalUrl: apiBaseUrl
		// });

		axios.get(apiBaseUrl, {
			params: data,
			headers: requestHeaders
		}).then((response) => {
			resolve(response);
		}).catch((error) => {
			reject(error);
			if (invokeError) {
				errorHandlingBlock(error, header === "webhook")
			}
		})
	});
}

// ---- lightweight in-memory GET cache (master/reference data) ----
const apiCache = new Map();

/**
 * Cached GET. Returns the stored response when the same url+params were
 * fetched within ttlMs; otherwise performs a real request and stores it.
 * In-memory only - clears on reload/logout. Use for slowly-changing
 * reference data (stores, categories, units, suppliers, tax codes...).
 */
export const getCached = (url, data, ttlMs = 5 * 60 * 1000, header = "global", customHeaders = null) => {
	const userEntry = Store.default?.getState?.()?.LoginReducer?.userEntryType;
	const orgContext = typeof userEntry === 'object' && userEntry !== null
		? (userEntry.org_id || userEntry.id || '')
		: '';
	const key = `${orgContext}|${url}|${JSON.stringify(data || {})}`;
	const cached = apiCache.get(key);
	if (cached && (Date.now() - cached.ts) < ttlMs) {
		return Promise.resolve(cached.response);
	}
	return get(url, data, header, customHeaders).then((response) => {
		apiCache.set(key, { response, ts: Date.now() });
		return response;
	});
};

/**
 * Invalidate cached GETs. `substring` limits invalidation to keys whose URL
 * contains it (e.g. invalidateApiCache('store') after a store edit);
 * omitted clears everything.
 */
export const invalidateApiCache = (substring = null) => {
	if (!substring) {
		apiCache.clear();
		return;
	}
	for (const key of apiCache.keys()) {
		if (key.includes(substring)) apiCache.delete(key);
	}
};

// post api api configure fn
export const post = (url, data, header = "global", customHeaders = null) => {
	return new Promise((resolve, reject) => {
		// Check if URL is external (starts with http:// or https://)
		let apiBaseUrl;
		if (url.startsWith('http://') || url.startsWith('https://')) {
			apiBaseUrl = url; // Use external URL as-is
		} else {
			apiBaseUrl = normalizeUrl(`${process.env.BASE_URL}${url}`); // Use internal URL with base
		}

		let requestHeaders = getHeaders(header, url);

		// Merge custom headers if provided
		if (customHeaders && typeof customHeaders === 'object') {
			requestHeaders = { ...requestHeaders, ...customHeaders };
		}

		axios.post(apiBaseUrl, data, { headers: requestHeaders }).then((response) => {
			// Invalidate cached GETs for the touched resource segment
			const seg = apiBaseUrl.split('?')[0].split('/').filter(Boolean).pop();
			if (seg) invalidateApiCache(seg);
			resolve(response);
		}).catch((error) => {
			reject(error);
			errorHandlingBlock(error, header === "webhook")
		})
	});
}

// patch api api configure fn
export const patch = (url, data, header = "global", customHeaders = null) => {
	return new Promise((resolve, reject) => {
		// Check if URL is external (starts with http:// or https://)
		let apiBaseUrl;
		if (url.startsWith('http://') || url.startsWith('https://')) {
			apiBaseUrl = url; // Use external URL as-is
		} else {
			apiBaseUrl = normalizeUrl(`${process.env.BASE_URL}${url}`); // Use internal URL with base
		}

		let requestHeaders = getHeaders(header, url);

		// Merge custom headers if provided
		if (customHeaders && typeof customHeaders === 'object') {
			requestHeaders = { ...requestHeaders, ...customHeaders };
		}

		axios.patch(apiBaseUrl, data, { headers: requestHeaders }).then((response) => {
			const seg = apiBaseUrl.split('?')[0].split('/').filter(Boolean).pop();
			if (seg) invalidateApiCache(seg);
			resolve(response);
		}).catch((error) => {
			reject(error);
			errorHandlingBlock(error, header === "webhook")

		})
	});
}

// put api api configure fn
export const put = (url, data, header = "global") => {
	return new Promise((resolve, reject) => {
		let apiBaseUrl = normalizeUrl(`${process.env.BASE_URL}${url}`);
		axios.put(apiBaseUrl, data, { headers: getHeaders(header, url) }).then((response) => {
			const seg = apiBaseUrl.split('?')[0].split('/').filter(Boolean).pop();
			if (seg) invalidateApiCache(seg);
			resolve(response);
		}).catch((error) => {
			reject(error);
			errorHandlingBlock(error, header === "webhook")
		})
	});
}

// delete api api configure fn
export const del = (url, data, header = "global") => {
	return new Promise((resolve, reject) => {
		let apiBaseUrl = normalizeUrl(`${process.env.BASE_URL}${url}`);
		axios.delete(apiBaseUrl, {
			data: data,
			headers: getHeaders(header, url)
		}).then((response) => {
			const seg = apiBaseUrl.split('?')[0].split('/').filter(Boolean).pop();
			if (seg) invalidateApiCache(seg);
			resolve(response);
		}).catch((error) => {
			reject(error);
			errorHandlingBlock(error, header === "webhook")
		})
	});
}

// download api configure fn
export const download = (url, data, header = "global") => {
	return new Promise((resolve, reject) => {
		let apiBaseUrl = normalizeUrl(`${process.env.BASE_URL}${url}`);
		axios.get(apiBaseUrl, {
			params: data,
			headers: getHeaders(header, url),
			responseType: 'blob'
		}).then((response) => {
			resolve(response);
		}).catch((error) => {
			reject(error);
			errorHandlingBlock(error, header === "webhook")
		})
	});
}

//Api header configure fn
export const getHeaders = (header, path = "") => {
	// Check if path is external URL - don't add internal headers for external APIs
	const isExternalUrl = path.startsWith('http://') || path.startsWith('https://');

	if (!isExternalUrl) {
		checkExpiryOfToken()
	}

	// let headers = {'ngrok-skip-browser-warning': 'true'};
	let headers = (!isExternalUrl && process.env.BASE_URL.includes('ngrok'))
		? { 'ngrok-skip-browser-warning': 'true' }
		: {};
	// let headers = {};
	// headers['language'] = localStorage.getItem('i18nextLng');

	// Only add business_details for internal APIs
	if (!isExternalUrl && ![`${process.env.EXTENDED_URL_WITHOUT_VERSION}login`, `${process.env.EXTENDED_URL_WITHOUT_VERSION}users/user_details`].includes(path)) {
		const activeStoreId = localStorage.getItem('store_id');
		const userEntry = Store.default?.getState?.()?.LoginReducer?.userEntryType;
		const bDetails = typeof userEntry === 'object' && userEntry !== null ? { ...userEntry } : (userEntry ? JSON.parse(userEntry) : {});
		if (activeStoreId) {
			bDetails.branch_id = Number(activeStoreId);
			bDetails.store_id = Number(activeStoreId);
			headers['store_id'] = activeStoreId;
		}
		headers['business_details'] = JSON.stringify(bDetails);
	}

	// Check for webhook authentication header type
	if (header === "webhook") {
		// Check if path is from Bill posting to use specific API key
		if (path && path.includes('bill_posting')) {
			// Use BILLPOST_API_KEY for bill posting endpoints
			const billPostApiKey = process.env.BILLPOST_API_KEY;

			if (billPostApiKey) {
				headers['x_ms_api_key'] = billPostApiKey;
			} else {
				console.error('❌ Bill posting API key not found! Set BILLPOST_API_KEY in environment variables');
			}
		} else {
			// Add webhook API key header for digital menu access
			const webhookApiKey = process.env.WEBHOOK_API_KEY;
			// console.log('🔑 Webhook Header Setup:', {
			// 	headerType: header,
			// 	webhookApiKey: webhookApiKey ? `${webhookApiKey}` : 'NOT FOUND',
			// 	path: path,
			// 	fullHeaders: { ...headers, 'x-wh-api-key': webhookApiKey ? `${webhookApiKey}` : 'NOT SET' }
			// });

			if (webhookApiKey) {
				// headers['x-wh-api-key'] = webhookApiKey;
				headers['x_wh_api_key'] = webhookApiKey;
			} else {
				console.error('❌ Webhook API key not found! Set it with: localStorage.setItem("webhook_api_key", "your_key")');
			}
		}
		return headers;
	} else if (header == null) {
		// headers['language'] = localStorage.getItem('i18nextLng');
	} else if (header == "global") {
		// Skip internal authentication headers for external URLs
		if (!isExternalUrl) {
			if (path == `${process.env.EXTENDED_URL_WITHOUT_VERSION}mfa/verify`) {
				headers["Session"] = Store.default.getState().LoginReducer.session
			} else if (path == `${process.env.EXTENDED_URL_WITHOUT_VERSION}otp/verify`) {
				headers["Session"] = Store.default.getState().LoginReducer.session
			} else if (path == `${process.env.EXTENDED_URL_WITHOUT_VERSION}usr_mfa_assign`) {

			} else if (path == `${process.env.EXTENDED_URL_WITHOUT_VERSION}associate_software_token`) {
				headers["AccessToken"] = Store.default.getState().LoginReducer.accessToken;
			} else if (path == `${process.env.EXTENDED_URL_WITHOUT_VERSION}verify_software_token`) {
				headers["AccessToken"] = Store.default.getState().LoginReducer.accessToken;
			} else {
				headers["Authorization"] = Store.default.getState().LoginReducer.token;
			}
		}
	} else if (Object.keys(header).length > 0) {
		// Skip internal authentication headers for external URLs
		if (!isExternalUrl) {
			if (path == `${process.env.EXTENDED_URL_WITHOUT_VERSION}userforcepasswordchange`) {
				Object.keys(header).map((key, idx) => {
					headers[key] = header[key];
				})
			} else if (path == `${process.env.EXTENDED_URL_WITHOUT_VERSION}signout`) {
				localStorage.setItem('i18nextLng', 'en');
				headers["Authorization"] = Store.default.getState().LoginReducer.token;
				headers["Accesstoken"] = Store.default.getState().LoginReducer.accessToken;
			} else if (path == `${process.env.EXTENDED_URL_WITHOUT_VERSION}changepassword`) {
				headers["Authorization"] = Store.default.getState().LoginReducer.token;
				headers["Accesstoken"] = Store.default.getState().LoginReducer.accessToken;
			}
		}
	}
	return headers
};

//id token expiration time check fn before every api call hits
export const checkExpiryOfToken = () => {
	let currentDateTime = new Date();
	const expiryTime = new Date(Store.default.getState().LoginReducer.expiresIn.expiryTime)
	const loggedInTime = new Date(Store.default.getState().LoginReducer.expiresIn.loggedInTime)
	const expiryInterval = Store.default.getState().LoginReducer.expiresIn.expiryInterval
	if (expiryTime != "") {
		let deltaDifference = ((currentDateTime == "" ? 0 : currentDateTime) - (loggedInTime == "" ? 0 : loggedInTime)) / 1000
		if (currentDateTime >= expiryTime && (deltaDifference <= expiryInterval)) {
			refershToken()
		}
	}
};

//refershToken create api method
export const refershToken = () => {
	const history = createHashHistory();
	let res = new Promise((resolve, reject) => {
		let header = {};
		header["Authorization"] = Store.default.getState().LoginReducer.token;
		header["refreshToken"] = Store.default.getState().LoginReducer.refreshToken;
		let apiBaseUrl = normalizeUrl(`${process.env.BASE_URL}${process.env.EXTENDED_URL_WITHOUT_VERSION}refreshtoken`);
		let data = {}
		// data["refreshToken"] = Store.default.getState().LoginReducer.refreshToken;
		axios.patch(apiBaseUrl, data, { headers: header }).then((response) => {
			resolve(response);
		}).catch((error) => {
			console.log("error", error)
			logoutApp()
		})
	});
	res.then((result) => {
		let finalResponse = result.data
		if (finalResponse.success) {
			const finalIdToken = finalResponse.data.tokenType + ' ' + finalResponse.data.idToken;
			const accessToken = finalResponse.data.accessToken
			const expiresIn = LoginUtility.getExpiryDetails(finalResponse.data.expiresIn)
			Store.default.dispatch({
				type: LoginActionTypes.SET_TOKEN,
				payload: finalIdToken
			});
			Store.default.dispatch({
				type: LoginActionTypes.SET_ACCESS_TOKEN,
				payload: accessToken
			});
			Store.default.dispatch({
				type: LoginActionTypes.SET_TOKEN_EXPIRE_TIME,
				payload: expiresIn
			});
		} else {
			LoginUtility.toastNotifications("Oops session has been expired!!!", "Error", "error")
			logoutApp()
		}
	})

};

//logoutApp fn
export const logoutApp = async () => {
	// Preserve the current language across the localStorage wipe - without this,
	// post-logout redirects read a null i18nextLng and produce /null/login
	const lng = localStorage.getItem('i18nextLng') || 'en';
	const history = createHashHistory();
	try {
		const header = {
			"Authorization": Store.default.getState().LoginReducer.token,
			"Accesstoken": Store.default.getState().LoginReducer.accessToken
		};
		const apiBaseUrl = normalizeUrl(`${process.env.BASE_URL}${process.env.EXTENDED_URL_WITHOUT_VERSION}signout`);
		await axios.delete(apiBaseUrl, {
			data: {},
			headers: header
		});
		Store.default.dispatch({
			type: LoginActionTypes.LOGOUT,
			payload: { "token": "", "accessToken": "", "refreshToken": "", "userGroup": [], "organisationGroup": [], "userEntryType": "", "expiresIn": { "loggedInTime": "", "expiryTime": "", "expiryInterval": "" }, "userCredentials": {}, version: [], "roleWisePermission": {} }
		});
		Store.default.dispatch({
			type: AllActionTypes.CLEAR_DATA,
			payload: { "loaderState": false, "leftbar": false, "activeLink": { 'accName': "", 'activeClass': "" }, "roleWisePermission": {} }
		});
		Store.default.dispatch({
			type: CLEAR_STORES
		});
		history.push(`/${lng}/login`);
		localStorage.clear();
		localStorage.setItem('i18nextLng', lng);
		window.location.reload();
	} catch (error) {
		console.log(error)
	}
};

//error handler fn for api errors
export const errorHandlingBlock = (error, isWebhookAuth = false) => {
	const history = createHashHistory();
	if (error.response) {
		if (error.response.status == 413) {
			if (Array.isArray(error.response.data)) {
				LoginUtility.toastNotifications(error.response.data[0].message, "Error", "error");
			} else {
				LoginUtility.toastNotifications(error.response.data.message, "Error", "error")
			}
		}

		if (error.response.status == 409) {
			if (Array.isArray(error.response.data)) {
				if (error.response.data.length > 0) {
					error.response.data.map((item) => {
						LoginUtility.toastNotifications(item.message, "Error", "error");
					});
				}
			} else {
				if (error.response.data.message == "Same credential exists with different parametes") {
					LoginUtility.toastNotifications(error.response.data.message, "Info", "info");
				} else {
					LoginUtility.toastNotifications(error.response.data.message, "Error", "error");
				}
			}
		}

		if (error.response.status == 406) {
			if (Array.isArray(error.response.data)) {
				LoginUtility.toastNotifications(error.response.data[0].message, "Error", "error");
			} else {
				if (error.response.data.message == "Please make sure you have done full payments before checkout") {
					LoginUtility.toastNotifications(error.response.data.message, "Warning", "warning");
				} else if (error.response.data.message.indexOf('Check-Out is not possible as payment of amount') !== -1) {
					LoginUtility.toastNotifications(error.response.data.message, "Warning", "warning");
				} else {
					LoginUtility.toastNotifications(error.response.data.message, "Error", "error");
				}
			}
		}
		if (error.response.status == 400) {
			if (Array.isArray(error.response.data)) {
				LoginUtility.toastNotifications(error.response.data[0].message, "Error", "error");
			} else {
				if (error.response.data.message != "Customer details already updated") {
					if (error.response.data.message.indexOf("To create a new property, please deactivate an existing branch.") !== -1) {
						LoginUtility.toastNotifications(error.response.data.message, "Warning", "warning");
					} else if (error.response.data.message.indexOf("Cannot proceed booking as active list have more than") !== -1) {
						LoginUtility.toastNotifications(error.response.data.message, "Warning", "warning");
					} else {
						if (error.response.data.message != 'Restaurant table not found or inactive')
							LoginUtility.toastNotifications(error.response.data.message, "Error", "error")
					}
				}
			}
		}

		if (error.response.status == 404) {
			if (Array.isArray(error.response.data)) {
				if (error.response.data[0].message)
					if (error.response.data[0].message.indexOf('Please settle them individually first') == -1) {
						LoginUtility.toastNotifications(error.response.data[0].message, "Error", "error");
					}
			} else {
				LoginUtility.toastNotifications(error.response.data.message, "Error", "error")
			}
		}
		if (error.response.status == 422) {
			if (Array.isArray(error.response.data)) {
				LoginUtility.toastNotifications(error.response.data[0].message, "Warning", "warning");
			} else {
				LoginUtility.toastNotifications(error.response.data.message, "Warning", "warning")
			}
		}

		if (error.response.status == 500) {
			if (error.response.data.message == "Invalid signature") {
				LoginUtility.toastNotifications(error.response.data.message, "Error", "error");
				Store.default.dispatch({
					type: LoginActionTypes.LOGOUT,
					payload: { "token": "", "accessToken": "", "refreshToken": "", "userGroup": [], "organisationGroup": [], "userEntryType": "", "expiresIn": { "loggedInTime": "", "expiryTime": "", "expiryInterval": "" }, "userCredentials": {}, version: [], "roleWisePermission": {} }
				});
				Store.default.dispatch({
					type: AllActionTypes.CLEAR_DATA,
					payload: { "loaderState": false, "leftbar": false, "activeLink": { 'accName': "", 'activeClass': "" }, "roleWisePermission": {} }
				});
				Store.default.dispatch({
					type: CLEAR_STORES
				});
				const lng = localStorage.getItem('i18nextLng') || 'en';
				history.push(`/${lng}/login`);
				localStorage.clear();
				localStorage.setItem('i18nextLng', lng);
				window.location.reload();
			}
		}

		if (error.response.status == 401) {
			// console.log('🚨 401 Authentication Error:', {
			// 	isWebhookAuth,
			// 	errorMessage: error.response.data?.message,
			// 	url: error.config?.url,
			// 	method: error.config?.method,
			// 	currentPath: window.location.pathname,
			// 	currentHash: window.location.hash
			// });

			// Check if this is an external API test call (skip logout for external API testing)
			const isExternalApiTest = window.location.hash.includes('/bill-posting-settings');

			// Check if this is a request to restricted URLs that should not trigger logout
			const requestUrl = error.config?.url || '';
			const isRestrictedUrl = requestUrl.includes('/rooms') || requestUrl.includes('/bill-posting') || requestUrl.includes('/acknowledgement-status');

			if (isWebhookAuth) {
				// For webhook authentication failures, show error but DON'T redirect to login for public menu
				console.log('❌ Webhook authentication failed:', error.response.data.message);
				const isPublicMenuRoute = window.location.hash.includes('/our_menu/') || window.location.hash.includes('/full_menu/');

				if (isPublicMenuRoute) {
					console.log('🔄 Public menu route detected, not redirecting to login');
					LoginUtility.toastNotifications(error.response.data.message || 'Webhook authentication failed. Please check your access.', "Error", "error");
					// Don't call logoutApp() for public menu routes
					return;
				} else {
					LoginUtility.toastNotifications(error.response.data.message || 'Webhook authentication failed', "Error", "error");
				}
			} else if (isExternalApiTest) {
				// For external API testing, don't logout - just log the error
				console.log('❌ External API test failed:', error.response.data.message);
				// Don't call logoutApp() for external API tests
				return;
			} else if (isRestrictedUrl) {
				// For restricted URLs (/rooms, /bill-posting), don't logout - just log the error
				console.log('❌ Restricted URL 401 error:', error.response.data.message, 'URL:', requestUrl);
				LoginUtility.toastNotifications(error.response.data.message || 'Access denied for this resource', "Error", "error");
				// Don't call logoutApp() for restricted URLs
				return;
			} else {
				// For regular authentication failures
				if (error.response.data.message == "The incoming token has expired") {
					LoginUtility.toastNotifications("Oops session has been expired!!!", "Error", "error")
					Store.default.dispatch({
						type: LoginActionTypes.LOGOUT,
						payload: { "token": "", "accessToken": "", "refreshToken": "", "userGroup": [], "organisationGroup": [], "userEntryType": "", "expiresIn": { "loggedInTime": "", "expiryTime": "", "expiryInterval": "" }, "userCredentials": {}, version: [], "roleWisePermission": {} }
					});
					Store.default.dispatch({
						type: AllActionTypes.CLEAR_DATA,
						payload: { "loaderState": false, "leftbar": false, "activeLink": { 'accName': "", 'activeClass': "" }, "roleWisePermission": {} }
					});
					Store.default.dispatch({
						type: CLEAR_STORES
					});
					const lng = localStorage.getItem('i18nextLng') || 'en';
					history.push(`/${lng}/login`);
					localStorage.clear();
					localStorage.setItem('i18nextLng', lng);
					window.location.reload();
				}
			}
			// Only redirect to login page for non-public routes and non-restricted URLs
			const isPublicMenuRoute = window.location.hash.includes('/our_menu/') || window.location.hash.includes('/full_menu/');
			if (!isPublicMenuRoute && !isExternalApiTest && !isRestrictedUrl) {
				console.log('🔄 Redirecting to login page');
				logoutApp()
			} else {
				console.log('🔄 Skipping login redirect for public menu route or restricted URL');
			}
			if (error.response.data.message == "The incoming token has expired") {
				LoginUtility.toastNotifications("Oops session has been expired!!!", "Error", "error")
			}
			// logoutApp()
		} else if (error.response.data) {
			if (error.response.data.message != 'Customer details already updated' && error.response.data.message != 'Restaurant table not found or inactive' && error.response.data.message != "Same credential exists with different parametes") {
				LoginUtility.toastNotifications(error.response.data.message, "Error", "error")
			}
		}
	} else {
		if (error.message != "Customer details already updated" || error.message!="Same credential exists with different parametes") {
			LoginUtility.toastNotifications(error.message, "Error", "error")
		}
	}
}

//set idToken in redux fn
export const setToken = (value) => {
	Store.default.dispatch({
		type: LoginActionTypes.SET_TOKEN,
		payload: value
	})
};

// Remove duplicate slashes except after protocol (http:// or https://)
export const normalizeUrl = (url) => {
	return url.replace(/([^:]\/)\/+/g, '$1');
};